export enum EnumTipoFaturamentoSistema {
    Padrao = 0,
    Regra15Dias = 1,
    RegraProximoMes = 2,
}

export const EnumTipoFaturamentoSistemaLabel: Record<EnumTipoFaturamentoSistema, string> = {
    [EnumTipoFaturamentoSistema.Padrao]: 'Padrão — bonifica o mês da adesão e o seguinte',
    [EnumTipoFaturamentoSistema.Regra15Dias]: 'Regra 15 dias — cobra no mês seguinte se aderir até o dia 15',
    [EnumTipoFaturamentoSistema.RegraProximoMes]: 'Próximo mês — sempre cobra no mês seguinte',
}

export const EnumTipoFaturamentoSistemaDescricao: Record<EnumTipoFaturamentoSistema, string> = {
    [EnumTipoFaturamentoSistema.Padrao]: 'O mês da adesão e o seguinte nascem bonificados. A primeira cobrança só vem depois desses dois meses.',
    [EnumTipoFaturamentoSistema.Regra15Dias]: 'Se aderir até o dia 15, cobra no mês seguinte. Depois do dia 15, bonifica a adesão e o mês seguinte.',
    [EnumTipoFaturamentoSistema.RegraProximoMes]: 'Sempre cobra no mês seguinte à adesão, em qualquer dia (1 a 31).',
}
